import type { ListControlConfig } from '../declare'
import { useState, useEffect, useContext } from 'react'
import { autorun } from 'mobx'
import { Form } from 'antd'
import { ListSearchContext } from 'src/components'
import * as Header from './header'
import { $consts } from 'src/plugins'
import { get } from 'lodash'

/**
 * 列表表单查询配置控件
 * @param props 
 * @returns 
 */
const HeaderControl = (props: { config: ListControlConfig }) => {
  const search = useContext(ListSearchContext)

  // 控件值
  const [value, setValue] = useState()
  useEffect(() => autorun(() => {
    const { QUERY_NAME } = props.config
    setValue(get(search?.formBase, QUERY_NAME))
  }), [props.config])

  // 控件 change 事件
  const handleChange = (value: any, extra: any) => {
    const { QUERY_NAME } = props.config
    search?.setFormBase({ [QUERY_NAME]: value, ...extra })
  }

  const getControl = () => {
    const { DATA_TYPE } = props.config
    switch (DATA_TYPE) {
      // 文本框控件
      case $consts['TABLE/DATA_TYPE_TEXTINPUT']:
        return (
          <Header.TextInput
            value={value}
            config={props.config}
            onChange={handleChange}
          />
        )
      // 枚举下拉单选
      case $consts['TABLE/DATA_TYPE_ENUM_SELECT']:
        return (
          <Header.EnumSelect
            value={value}
            config={props.config}
            onChange={handleChange}
          />
        )
      // 枚举下拉单选
      case $consts['TABLE/DATA_TYPE_SWITCH']:
        return (
          <Header.SwitchControl
            value={value}
            config={props.config}
            onChange={handleChange}
          />
        )
      // 枚举下拉多选
      case $consts['TABLE/DATA_TYPE_ENUM_MULTI_SELECT']:
        return (
          <Header.EnumMultiSelect
            value={value}
            config={props.config}
            onChange={handleChange}
          />
        )
      // 级联选择、树下拉
      case $consts['TABLE/DATA_TYPE_CASCADER_SELECT']:
      case $consts['TABLE/DATA_TYPE_TREE_SELECT']:
        return (
          <Header.TreeSelect
            value={value}
            config={props.config}
            onChange={handleChange}
          />
        )
      // 时间控件类型
      case $consts['TABLE/DATA_TYPE_DATE_RANGE_DAY_SECOND']:
      case $consts['TABLE/DATA_TYPE_DATE_RANGE_DAY_MINUTE']:
      case $consts['TABLE/DATA_TYPE_DATE_DAY']:
      case $consts['TABLE/DATA_TYPE_DATE_RANGE_DAY']:
      case $consts['TABLE/DATA_TYPE_DATE_MONTH']:
      case $consts['TABLE/DATA_TYPE_DATE_RANGE_MONTH']:
      case $consts['TABLE/DATA_TYPE_DATE_YEAR']:
      case $consts['TABLE/DATA_TYPE_DATE_RANGE_YEAR']:
        return (
          <Header.DateControl
            value={value}
            config={props.config}
            onChange={handleChange}
          />
        )
      // 分页下拉组件
      case $consts['TABLE/DATA_TYPE_PAGINATION_SELECT']:
        return (
          <Header.PaginationSelect
            value={value}
            config={props.config}
            onChange={handleChange}
          />
        )
      default:
        return <div />
    }
  }

  const { LABEL } = props.config
  return (
    <Form.Item label={LABEL}>
      {getControl()}
    </Form.Item>
  )
}

export default HeaderControl